import type { InjectionKey } from 'vue'

export type CheckboxValue = string | number

export interface CheckboxGroupCtx {
    values: () => Set<CheckboxValue>
    toggle: (v: CheckboxValue) => void
    has: (v: CheckboxValue) => boolean
    name: string
    disabled?: boolean
}

export const CheckboxGroupKey: InjectionKey<CheckboxGroupCtx> = Symbol('CheckboxGroup')


